export default {
  // 步骤一
  step1: {
    text: "第一步：在钉钉群",
    settings: "设置",
    text2: "浮窗，选择",
    addRobot: "添加机器人",
    text3: "，选择",
    custom: "自定义",
    text4: "机器人",
  },

  // 步骤二
  step2: {
    text: "第二步：点击确认添加",
    robot: "机器人",
    text2: "安全设置选项勾选",
    signatureVerification: "签名校验",
    text3: "，点击确认钉钉群机器人配置完成",
  },

  // 步骤三
  step3: {
    text: "第三步：点击完成添加",
    robot: "机器人",
    text2:
      "成功之后，在群设置->群机器人找到该机器人点开信息，可复制钉钉机器人webhook和签名校验",
  },

  // 步骤四
  step4: {
    text: "第四步：将复制的钉钉机器人标签密钥和钉钉机器人Webhook粘贴到地址监控钉钉对应选项",
  },
};
